import { CfMarketingCard } from 'ggApp/modules/contentful/models/MarketingCard';
import { CfCampaignBanner } from '../../models';

/**
 * This function maps home page contetnful data
 * to the home promo page class constructor data.
 * @export
 * @param {*} [cfEntity={}]
 * @returns
 */
export function mapCfEntityToCfHomePage(cfEntity = {}) {
    const { fields } = cfEntity;

    const result = {};

    const {
        name,
        store_code: storeCode,
        logged,
        top_banner: topBanner,
        topBannerSlider,
        mc2,
        mc3,
    } = fields || {};

    Object.assign(result, {
        name,
        storeCode,
        logged,
        campaignBanner: topBanner && CfCampaignBanner.mapCfEntity(topBanner),
        campaignBannerCarousel:
            topBannerSlider &&
            topBannerSlider.map((banner) => CfCampaignBanner.mapCfEntity(banner)),
        mc2: mc2 && CfMarketingCard.mapCfEntity(mc2),
        mc3: mc3 && CfMarketingCard.mapCfEntity(mc3),
    });

    return result;
}
